import Cookies from 'js-cookie'
import md5 from 'js-md5'
import sha1 from 'sha1'
import defaultSettings from '@/settings'
const TokenKey = 'vue_admin_template_token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getRequestSignature (timestamp) {
  return md5(sha1(defaultSettings.appid + timestamp) + defaultSettings.app_secret)
}

export function getAccessSignature (params, timestamp) {
  let requestUri = ''
  if (params) {
    let arr = []
    for (var key in params) {
      arr.push(key)
    }
    arr.sort()
    let str = ''
    for (var i in arr) {
      if (params[arr[i]] === 0 || params[arr[i]] === '0' || !(isEmpty(params[arr[i]]))) {
        str += arr[i] + '=' + params[arr[i]] + '&'
      }
    }
    requestUri = str.substr(0, str.length - 1)
  }
  return md5(sha1(requestUri + timestamp) + getToken())
}

export function isEmpty (data) {
  if (typeof (data) === 'undefined') {
    return true
  }
  if (typeof (data) === 'string') {
    data = data.replace(/\s/g, '')
    if (data === '') {
      return true
    }
  }
  if (data === '') {
    return true
  }
  if (data.length === 0) {
    return true
  }
  if (typeof (data) === 'object') {
    if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
      return true
    }
    for (var key in data) {
      return false
    }
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/auth.js